module.exports = __webpack_public_path__ + "img/isxpay.f01e0fa0.svg";